import * as React from "react";

import { Margins, SkeletonGenerator, Container } from "@ui/Atoms";
import {
  BlockPageSkeleton,
  SidebarSkeleton as GenericSidebarSkeleton,
} from "@ui/Skeletons/Skeletons";

const ProcessSkeleton = React.memo(() => (
  <Container>
    <Margins xs={["base_x3", null, null, null]}>
      <div>
        <BlockPageSkeleton />
      </div>
    </Margins>
  </Container>
));

ProcessSkeleton.displayName = "ProcessSkeleton";

const PageSkeleton = React.memo(() => (
  <Margins xs={["base_x3", null, null, null]}>
    <div>
      <BlockPageSkeleton />
    </div>
  </Margins>
));

PageSkeleton.displayName = "PageSkeleton";

const SidebarSkeleton = React.memo(() => <GenericSidebarSkeleton />);
SidebarSkeleton.displayName = "SidebarSkeleton";

const CheckoutPageSkeleton = React.memo(() => (
  <Margins xs={["base_x3", null, null, null]}>
    <div>
      <SkeletonGenerator
        noGutter
        shape="rectVertical"
        count={2}
        randomHeight={170}
      />
      <SkeletonGenerator shape="rectVertical" count={6} randomHeight={190} />
    </div>
  </Margins>
));

CheckoutPageSkeleton.displayName = "CheckoutPageSkeleton";

export { SidebarSkeleton, PageSkeleton, CheckoutPageSkeleton, ProcessSkeleton };
